import { GlobalState } from '@/containers/GlobalState';
import React, { useContext } from 'react';

import {getConnectedEdges, Handle, Position, useReactFlow} from 'reactflow';


export default function InputHandle({nodeHighlighting}) {
    const { inAColors } = useContext(GlobalState);

    const {getNode, getEdges} = useReactFlow();

    const isValidInputConnection = (connection) => {
        if (connection.target === connection.source) {
            return false
        }
        let isValid = true
        const edges = getConnectedEdges([getNode(connection.source)], getEdges())
        if (edges.length > 0) {
            edges.map(({source, sourceHandle}) => {
                if (source === connection.source && sourceHandle === connection.sourceHandle) {
                    isValid = false
                }
            })
        }
        return isValid
    }

    const getColor = () => {
        if (nodeHighlighting?.input) {
            if (nodeHighlighting?.error) {
                return inAColors.error[600]
            }
            if (nodeHighlighting?.info) {
                return inAColors.warning[600]
            }
        }
        return inAColors.primary[900]
    }

    return (
        <Handle
            type='target'
            position={Position.Left}
            id='input'
            style={{top: 28, background: getColor(), width: 10, height: 10}}
            isValidConnection={isValidInputConnection}
        />
    );
}
